export default __webpack_public_path__ + "static/esg-logo-ea2fe6757ad3dcab79328b8a4114e697.png";